module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "alphawallet.b6df19bd.svg";